export const THIRD_APP_ICON_CACHE: any = {};
